"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const TaskPage_1 = require("../../base/TaskPage");
const Button_1 = require("../../../components/button/Button");
const FormTextArea_1 = require("../../../../view/components/input/text/FormTextArea");
const autosave_1 = require("../../../../hooks/autosave");
const api_1 = __importDefault(require("../../../../api"));
const constants_1 = require("../../../../tasks/constants");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const Spacer_1 = require("../../../components/spacer/Spacer");
const validation_1 = require("../../../../hooks/validation");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const restrictedContent_1 = require("../../../../util/restrictedContent");
exports.default = (props) => {
    const { property, viewState, update, lastSaved, updaterError, getterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [descriptionLoading, setDescriptionLoading] = React.useState(false);
    const [valid, errMsg] = (0, validation_1.usePropertyValidation)('long_description', property);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.LISTING_DESCRIPTION, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement("div", { "data-testid": "description-page" },
                    React.createElement(MarginWrapper_1.MarginWrapper, null,
                        React.createElement(Paragraph_1.Paragraph, null, "The description tells guests all about the key features of your property. We need a full description like the one below, however, some channels produce descriptions for you."),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(merlin_info_panels_1.DidYouKnow, { id: 'description', colour: 'purple', text: "We can generate a description based on market insights so your property stands out to guests." }),
                        React.createElement(Button_1.Button, { "data-testid": "description-generator-button", label: "description-generator", loading: descriptionLoading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                setDescriptionLoading(true);
                                try {
                                    const { description } = yield api_1.default.propertyDescription.getPropertyDescription(props.propertyId);
                                    update({ long_description: description });
                                }
                                catch (_a) {
                                    // do nothing until we handle error state
                                }
                                finally {
                                    setDescriptionLoading(false);
                                }
                            }) }, "Generate a new description"),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(FormTextArea_1.FormTextArea, { label: "Description", id: "description-textarea", value: (property === null || property === void 0 ? void 0 : property.long_description) || '', name: "description", onChange: (_, value) => update({ long_description: value }), minLength: 400, maxLength: 9000, valid: valid, errorMessage: errMsg }),
                        React.createElement(Spacer_1.Spacer, null),
                        (0, restrictedContent_1.hasBadContent)(property === null || property === void 0 ? void 0 : property.long_description) ?
                            React.createElement(merlin_info_panels_1.DidYouKnow, { id: 'description-help', colour: { background: '#FFF0EC', text: 'rgba(17,34,58,0.650)' }, text: "Remove phone, email or website details to allow publishing on channels like Airbnb" })
                            : null))))));
};
//# sourceMappingURL=DescriptionPage.js.map